
      // Set RSS feed URL dynamically
      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
      if (supabaseUrl) {
        const rssLink = document.getElementById('rss-feed-link');
        if (rssLink) {
          rssLink.setAttribute('href', `${supabaseUrl}/functions/v1/rss-feed`);
        }
      }
    